import { useMutation } from "@tanstack/react-query";
import { logoutApi } from "../api/authService";
import { useAppDispatch } from "../../../app/hooks";
import { logout } from "../authSlice";
import { LogOutPayload } from "../types";
import { AuthResponse } from "../types";
import { toast } from "react-toastify";
import { clearSession } from "@/shared/utils/clearSession";


export const useLogout = () => {
  const dispatch = useAppDispatch();

  return useMutation<AuthResponse, Error, LogOutPayload>({
    mutationFn: (payload: LogOutPayload) => logoutApi(payload),

    // Toasts only — actual session teardown happens in onSettled below so
    // it runs unconditionally (success, server-rejected, network error,
    // tab closed mid-call). This guarantees no PHI/credentials leak to the
    // next user of the machine if the logout API call fails for any reason.
    onSuccess: (data) => {
      if (!data.success) {
        console.error("Logout failed:", data.responseMsg || "Unknown error");
        toast.error("Failed to logout");
      }
    },

    onError: (error) => {
      console.error("Logout request errored:", error);
      toast.error("Failed to logout");
    },

    onSettled: async () => {
      // Dispatch first so the UI flips to logged-out immediately; the
      // async storage/cache teardown runs in the background. Reducer is
      // now a pure state mutation (no I/O), so this is effectively
      // synchronous.
      dispatch(logout());
      await clearSession();
    },
  });
};
